import { CountryTag } from "@/components/Country";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

const Bar = ({ r, active, onPick }) => {
  const pct = (n) => `${(n / Math.max(r.total, 1)) * 100}%`;
  const done = r.published + r.built;
  return (
    <button data-testid={`region-bar-${slug(r.region)}`} onClick={() => onPick?.(active === r.region ? "" : r.region)}
      className={`text-left group transition-opacity ${active && active !== r.region ? "opacity-40" : ""}`}>
      <div className="flex items-baseline justify-between mb-1.5">
        <span className="font-display text-lg text-[#3B1B48] group-hover:text-[#C59B27] transition-colors">{r.region}</span>
        <span className="text-xs font-mono-accent text-[#8C827A]">{done}/{r.total}{r.building ? ` · ${r.building} building` : ""}</span>
      </div>
      <div className="h-2 bg-[#E2D9CC] flex overflow-hidden" title={`${r.published} published · ${r.built} built · ${r.building} building`}>
        <span className="bg-[#2D6A4F] transition-[width] duration-700" style={{ width: pct(r.published) }} />
        <span className="bg-[#C59B27] transition-[width] duration-700" style={{ width: pct(r.built) }} />
        <span className="bg-[#B45309]/50 transition-[width] duration-700" style={{ width: pct(r.building) }} />
      </div>
    </button>
  );
};

const Group = ({ c, rows, showHead, active, onPick }) => (
  <section data-testid={`region-group-${slug(c)}`}>
    {showHead && (
      <div className="flex items-center gap-3 mb-4 pb-2 border-b border-[#E2D9CC]">
        <CountryTag country={c} testId={`region-group-tag-${slug(c)}`} />
        <span className="text-xs text-[#8C827A]">{rows.length} region{rows.length === 1 ? "" : "s"} · {rows.reduce((n, r) => n + r.published + r.built, 0)}/{rows.reduce((n, r) => n + r.total, 0)} towns built</span>
      </div>
    )}
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-4">
      {rows.map((r) => <Bar key={`${r.country}-${r.region}`} r={r} active={active} onPick={onPick} />)}
    </div>
  </section>
);

export const RegionProgress = ({ onPick, active, refreshKey, country }) => {
  const [all, setRows] = useState([]);
  useEffect(() => { api.get("/towns/regions").then((r) => setRows(r.data)).catch(() => {}); }, [refreshKey]);
  const rows = country ? all.filter((r) => r.country === country) : all;
  if (!rows.length) return null;
  const groups = rows.reduce((a, r) => ({ ...a, [r.country]: [...(a[r.country] || []), r] }), {});
  const showHead = !country && Object.keys(groups).length > 1;
  return (
    <div data-testid="region-progress" className="space-y-10">
      {Object.entries(groups).map(([c, rs]) => <Group key={c} c={c} rows={rs} showHead={showHead} active={active} onPick={onPick} />)}
      <p className="text-[11px] text-[#8C827A] flex gap-4 items-center">
        <span className="flex items-center gap-1.5"><i className="w-3 h-2 bg-[#2D6A4F] inline-block" />Published</span>
        <span className="flex items-center gap-1.5"><i className="w-3 h-2 bg-[#C59B27] inline-block" />Built</span>
        <span className="flex items-center gap-1.5"><i className="w-3 h-2 bg-[#B45309]/50 inline-block" />Building</span>
      </p>
    </div>
  );
};
